<script lang="ts">
    import { programTypeIcon, shortProgramTypeTitle, xfaiProgramTypes, type ProgramType } from "@/Common/constants";
    import { cn } from "@/lib/utils";

    export let programType: ProgramType
    let className: string = undefined
    export {className as class}
</script>

<div class={cn("grid justify-items-center items-center text-center", className)}>
    <i class={`row-start-1 col-start-1 fa-solid ${programTypeIcon[programType]} text-xerteal-200/30 text-7xl`}/>
    <span class={`row-start-1 col-start-1 ${xfaiProgramTypes.includes(programType) ? 'text-4xl' : 'text-3xl'} text-xerteal-800 font-bold`}>{shortProgramTypeTitle[programType]}</span>
</div>